<ng-container *ngIf='variableMap'>
  <shared-ui-information-element [information]='getInformationElementAntragssteller()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getInformationElementStudium()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getInformationElementAntragstyp()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getInformationElementArbeitstitel()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getInformationElementBetreuer()'></shared-ui-information-element>
  <shared-ui-information-element [information]='getInformationElementOrganisation()'></shared-ui-information-element>
</ng-container>
